import { render } from "./UserBedWakeChart.vue?vue&type=template&id=ed493972&scoped=true"
import script from "./UserBedWakeChart.vue?vue&type=script&lang=js"
export * from "./UserBedWakeChart.vue?vue&type=script&lang=js"

import "./UserBedWakeChart.vue?vue&type=style&index=0&id=ed493972&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed493972"]])

export default __exports__